// Lightweight, dependency-free store for the API access token.
//
// This lives in its own module that imports NOTHING (no axios, no services) so
// it can be referenced from the root layout's <SessionProvider> without pulling
// the axios/service graph into every page's bundle. The in-memory cache lets the
// axios interceptor read the token synchronously and avoid a getSession()
// network round-trip on every request.

let cachedToken: string | null = null;

// Current cached access token (synchronous, no network).
export const getCachedToken = (): string | null => cachedToken;

// Read the access token from localStorage (synchronous, no network).
export const readTokenFromStorage = (): string | null => {
  if (typeof window === 'undefined') return null;
  const tokenData = localStorage.getItem('auth_token');
  if (!tokenData) return null;
  try {
    return JSON.parse(tokenData).access || null;
  } catch {
    return null;
  }
};

// Set the cached access token (and mirror it to localStorage). Called by
// <TokenSync /> whenever the NextAuth session changes, and by getToken() on
// cold-start.
export const setAuthToken = (token: string | null): void => {
  cachedToken = token;
  if (typeof window !== 'undefined') {
    if (token) {
      localStorage.setItem('auth_token', JSON.stringify({ access: token }));
    } else {
      localStorage.removeItem('auth_token');
    }
  }
};

// Clear the cached access token (called on 401/403 and logout).
export const clearAuthToken = (): void => {
  cachedToken = null;
  if (typeof window !== 'undefined') {
    localStorage.removeItem('auth_token');
  }
};
